import React from 'react';
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog/Dialog';
import Button from '../Button/Button';
import './SubscriptionDialog.css';

interface SubscriptionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string | React.ReactNode;
}

const SubscriptionDialog: React.FC<SubscriptionDialogProps> = ({
  isOpen,
  onClose,
  message
}) => {
  const navigate = useNavigate();

  const handleGoToTeam = () => {
    onClose();
    navigate('/app/team');
  };

  // Default message if none provided
  const defaultMessage = message || (
    <>
      Get AI translation, tone editing, and team collaboration features.
    </>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title=""
      showCloseButton={false}
      size="small"
      className="subscription-dialog-no-header"
    >
      <div className="subscription-dialog-content">
        <h2 className="subscription-dialog-title">Subscribe to translate in a breeze</h2>
        <div className="subscription-dialog-message">
          {defaultMessage}
        </div>
        <div className="subscription-dialog-actions">
          <Button
            variant="secondary"
            size="medium"
            onClick={onClose}
            className="subscription-dialog-button"
          >
            Maybe later
          </Button>
          <Button
            variant="primary"
            size="medium"
            onClick={handleGoToTeam}
            className="subscription-dialog-button"
          >
            View Plans
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default SubscriptionDialog;
